import { useResourceParams } from '@refinedev/core';
import { useMemo } from 'react';
import { Outlet } from 'react-router';

import SpinLoading from '@/components/general/SpinLoading';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { useInitialLoading } from '@/hooks/useInitialLoading';
import { useSelectScrollSearch } from '@/hooks/useSelectScrollSearch';

const ServiceOrdersSection = () => {
  const { action } = useResourceParams();

  useDocumentTitle({
    resourceTitle: 'Órdenes de servicio',
    showTitle: 'Ver orden de servicio {id}',
    editTitle: 'Editar orden de servicio {id}',
    createTitle: 'Nueva orden de servicio',
  });

  const { selectProps: companySelectProps } = useSelectScrollSearch(
    {
      resource: 'empresas',
      optionLabel: (item: any) => item.full_name,

      queryOptions: {
        queryKey: ['empresas'],
      },
    },
    {
      saveItem: true,
    },
  );
  const { selectProps: technicianSelectProps } = useSelectScrollSearch(
    {
      resource: 'technicians',
      optionLabel: (item: any) => item.nombre,
      optionValue: (item: any) => item.id ?? item.id,

      queryOptions: {
        queryKey: ['empresas', 'technicians'],
      },
    },
    {
      saveItem: true,
    },
  );
  const isLoading = useMemo(
    () => companySelectProps.loading || technicianSelectProps.loading,
    [companySelectProps.loading, technicianSelectProps.loading],
  );
  const { initialLoading } = useInitialLoading(isLoading);

  return (
    <div className="ServiceOrdersSection MainSection">
      {initialLoading ? (
        <SpinLoading />
      ) : (
        <Outlet context={{ companySelectProps, technicianSelectProps }} />
      )}
    </div>
  );
};

export default ServiceOrdersSection;
